import BaseCreateDefinitionObjectStrategy from './BaseCreateDefinitionObjectStrategy'
import {getMaxValuesOnPageProperty, getNeededImageDimensions} from '../ChartPDFDefinitionPartsConstructors'

export default class BaseBarsChartsStrategy extends BaseCreateDefinitionObjectStrategy {
    constructor(chartType) {
        super(chartType)
    }

    adjustDataParameters(pagesData, pdfPrintParameters) {
        // if need to show data list return original object
        if (this._needToShowTable(pdfPrintParameters)) {
            return pagesData
        }
        // another create page with two images
        const newPages = []
        let i = 0
        while (i < pagesData.length) {
            newPages.push(
                {
                    firstImage: pagesData[i].image,
                    secondImage: pagesData[++i] ? pagesData[i].image : null
                }
            )
            i++
        }
        return newPages
    }

    addPageDataWithDataList(ddBuilder, docDefinition, pageData, pdfPrintParameters, pageIndex) {
        ddBuilder.addImageAndData(
            docDefinition,
            pageData.image,
            pageData.data,
            pdfPrintParameters.showListOfDataValues,
            pdfPrintParameters.showListOfPercentValues,
            pdfPrintParameters.fitDataToOnePage,
        )
    }

    addPageDataWithoutDataList(ddBuilder, docDefinition, pageData, pdfPrintParameters, nPages) {
        ddBuilder.addDoubleImagesVertical(docDefinition, pageData.firstImage, pageData.secondImage)
    }

    getTotalNumberOfPages(lengthOfDataList, pdfPrintParameters) {
        if (pdfPrintParameters.fitDataToOnePage) {
            return 1
        } else {
            return this._needToShowTable(pdfPrintParameters) ?
                   Math.ceil(lengthOfDataList / pdfPrintParameters.barsOnPage) :
                   Math.ceil(lengthOfDataList / (2 * pdfPrintParameters.barsOnPage))
        }
    }

    getChartImageDimensions(lengthOfDataList, pdfPrintParameters) {
        const isDoubleImages = !this._needToShowTable(pdfPrintParameters)
        return getNeededImageDimensions(pdfPrintParameters.paperOrientation, pdfPrintParameters.paperSize, this.chartType, isDoubleImages)
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/charts/pdfgenerator/doStrategy/BaseBarsChartsStrategy.js